import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PARAM_PATHS } from '../navigation/paths.ts'
import { purchasesAllowed } from '../services/platform.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'
import { subscriptionsLink } from './subscriptions.tsx'

// A session and no role, like the list (spec §6). The native app never sells (App Review
// §3.1.1), so there the route sends back to the list instead of rendering.
export const subscriptionCheckoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PARAM_PATHS.subscriptionCheckout,
  params: numericIdParam('personId'),
  beforeLoad: async ({ context, location }) => {
    await guardRoute({ queryClient: context.queryClient, currentPath: location.href })
    if (!purchasesAllowed()) throw redirect(subscriptionsLink)
  },
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/subscription-checkout.tsx')),
})

export function subscriptionCheckoutLink(personId: number) {
  return { to: NAV_PARAM_PATHS.subscriptionCheckout, params: { personId } } as const
}
